import { useState, useEffect } from 'react';
import loadGoogleMaps from 'utils/googleMapsLoader';

/**
 * Warms the Google Maps JS API and reports its status. Called once from App.js so the API is already
 * there by the time a map page mounts; the loading itself lives in utils/googleMapsLoader, which is
 * also what the leaflet map components await, so the page only ever gets one script tag.
 */
const useGoogleMaps = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Synchronous fast path: already loaded, so don't make consumers wait a microtask for it.
    if (window.google && window.google.maps) {
      setIsLoaded(true);
      return;
    }

    loadGoogleMaps()
      .then(() => setIsLoaded(true))
      .catch((err) => setError(err.message));
  }, []);

  return { isLoaded, error };
};

export default useGoogleMaps;
